export const OpenRequestsIcon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M11.2675 3.25H2.16602V21.6667H21.7323L24.919 10.8333H22.7493V6.5H13.4342L11.2675 3.25ZM21.1243 10.8333V8.125H12.5645L10.3978 4.875H3.79102V20.0417H5.34974L8.05807 10.8333H21.1243Z" fill="#007BFF"/>
	</svg>
);

export const ClosedRequestsIcon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M5.41667 2.16699V8.66699H3.25V22.7503H22.7554V8.66699H20.5833V4.33366H13.8782L11.7115 2.16699H5.41667ZM18.9583 8.66699V5.95866H13.2051L11.0385 3.79199H7.04167V8.66699H18.9583ZM7.58333 13.0003H13.5417V14.6253H7.58333V13.0003Z" fill="#28A745"/>
	</svg>
);

export const UnassignedRequestsIcon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.2688 3.25H2.16732V13H7.58398V16.25H10.834V21.6667H23.834V6.5H13.4355L11.2688 3.25Z" fill="#6C757D"/>
		<path d="M5.95898 17.875V14.625H4.33398V17.875H1.08398V19.5H4.33398V22.75H5.95898V19.5H9.20898V17.875H5.95898Z" fill="#6C757D"/>
	</svg>
);

export const OverdueRequestsIcon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.2675 3.25H2.16602V11.5223C5.00795 9.61955 8.88905 9.92326 11.3992 12.4334C13.9094 14.9436 14.2131 18.8247 12.3104 21.6667H23.8327V6.5H13.4342L11.2675 3.25Z" fill="#DC3545"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M10.2502 13.5825C8.02908 11.3614 4.42795 11.3614 2.20685 13.5825C-0.0142612 15.8036 -0.0142612 19.4047 2.20685 21.6258C4.42795 23.8469 8.02908 23.8469 10.2502 21.6258C12.4713 19.4047 12.4713 15.8036 10.2502 13.5825ZM9.6182 19.8448L3.98788 14.2145C5.56524 13.1694 7.71139 13.3418 9.10114 14.7315C10.4909 16.1213 10.6632 18.2674 9.6182 19.8448ZM2.83883 15.3635L8.46915 20.9938C6.89179 22.0389 4.74564 21.8665 3.35589 20.4768C1.96614 19.087 1.79379 16.9409 2.83883 15.3635Z" fill="#DC3545"/>
	</svg>
);
